import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  style: {"width":"100%"}
}, null, -1)



export default /*#__PURE__*/_defineComponent({
  props: ['src', 'alt'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createBlock(_component_el_image, {
    referrerPolicy: "no-referrer",
    src: __props.src,
    alt: __props.alt
  }, {
    error: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["src", "alt"]))
}
}

})